const routing = {
  login: {
    path: '/login',
  },
  agentLogin: {
    path: '/agent-login',
  },
  resetAgentPassword: {
    path: '/reset-agent-password/{email}',
  },
  resetAgentPasswordSuccess: {
    path: '/reset-agent-password/{email}/success',
  },
  setAgentPassword: {
    path: '/set-agent-password',
  },
  resetPassword: {
    path: '/reset-password/{email}',
  },
  resetPasswordSuccess: {
    path: '/reset-password/{email}/success',
  },
  setPassword: {
    path: '/set-password',
  },
  dashboardDefault: {
    path: '/dashboard',
  },
  helpCenter: {
    path: '/new-help-center',
  },
  dashboard: {
    path: '/dashboard/{status}/{propertyId}/{fromDate}/{page}',
  },
  board: {
    path: '/board',
  },
  onboarding: {
    path: '/onboarding',
  },
  bookings: {
    path: '/dashboard',
  },
  students: {
    path: '/students',
    childRoutes: {
      list: {
        path: 'list',
      },
      detail: {
        path: '{id}/detail/{ongoing}',
      },
    },
  },
  reconciliation: {
    path: '/reconciliation',
    childRoutes: {
      list: {
        path: 'list',
      },
      detail: {
        path: 'detail/{id}',
      },
    },
  },
  orders: {
    path: '/booking',
    childRoutes: {
      list: {
        path: 'list',
      },
      detail: {
        path: '{id}/detail',
      },
      lead_details: {
        path: '{id}/lead_details',
      },
    },
  },
  paymentList: {
    path: '/payment/list',
  },
  paymentInitialSetup: {
    path: '/payment/setup/initial-setup',
  },
  enablePayments: {
    path: '/payment/setup/enable-payments',
  },
  fee: {
    path: '/payment/setup/fee',
  },
  instalment: {
    path: '/payment/setup/instalment',
  },
  freeCancelationPolicy: {
    path: '/payment/setup/free-cancelation-policy',
  },
  paymentReceivingPayments: {
    path: '/payment/setup/receiving-payments',
  },
  paymentDeposit: {
    path: '/payment/setup/deposit',
  },
  paymentFee: {
    path: '/payment/setup/fee',
  },
  paymentRentPayment: {
    path: '/payment/setup/rent-payment',
  },
  paymentFirstInstalment: {
    path: '/payment/setup/first-instalment',
  },
  paymentTerms: {
    path: '/payment/setup/terms-and-conditions',
  },
  paymentEnablePayments: {
    path: '/payment/setup/enable-payments',
  },
  paymentFinalizing: {
    path: '/payment/setup/finalizing',
  },
  paymentCallback: {
    path: '/payment/callback',
  },
  propertiesList: {
    path: '/properties',
  },
  withdrawal: {
    path: '/withdrawal',
    childRoutes: {
      list: {
        path: 'list',
      },
      edit: {
        path: '{id}/edit',
      },
      create: {
        path: 'create',
      },
    },
  },
  property: {
    path: 'property',
    childRoutes: {
      edit: {
        path: '{propertySlug}/edit',
      },
      homepage: {
        path: '{propertySlug}/homepage',
      },
      commission: {
        path: '{propertySlug}/commission',
      },
      depositAndFees: {
        path: '{propertySlug}/deposit-and-fees',
      },
      create: {
        path: 'create',
      },
      record: {
        path: '{propertySlug}/record',
      },
      terms: {
        path: '{propertySlug}/terms',
      },
    },
  },
  properties: {
    path: 'properties',
    childRoutes: {
      create: {
        path: 'create',
      },
      listings: {
        path: '{propertySlug}/listings',
        childRoutes: {
          create: {
            path: 'create',
          },
        },
      },
      unitTypes: {
        path: '{propertySlug}/unit-types',
        childRoutes: {
          create: {
            path: 'create',
          },
        },
      },
      distinctions: {
        path: '{propertySlug}/distinctions',
        childRoutes: {
          create: {
            path: 'create',
          },
        },
      },
      classification: {
        path: '{propertySlug}/classification',
        childRoutes: {
          create: {
            path: 'create',
          },
        },
      },
    },
  },
  comments: {
    path: '/comments/{propertySlug}',
  },
  account: {
    path: '/account',
  },
  accountProfile: {
    path: '/account/profile',
  },
  listingPlan: {
    path: '/account/listing-plan',
  },
  loginSecurity: {
    path: '/account/security',
  },
};

export default routing;
